module.exports = __webpack_public_path__ + "img/environment_loop.45119ce8.png";